<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col-md-8 mb-1">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Company Name, Email"
              aria-label="Company Name, Email"
              aria-describedby="Company Name, Email"
              v-model="search_text"
            />
            <div class="input-group-append">
              <button class="btn btn-info" type="button" @click="getEmployers(1)">Search</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark': ''"
        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
        tbody-classes="list"
        :data="employers"
      >
        <template slot="columns">
          <th class="text-center">#</th>
          <th class="text-center">Company Name</th>
          <th class="text-center">Email</th>
          <th class="text-center">Contact Person</th>
          <th class="text-center">Contact No.</th>
          <th class="text-center">Applied Date</th>
          <th class="text-center">Status</th>
        </template>

        <template slot-scope="{row, index}">
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{index+1+(10*(pageNumber-1))}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.company_name}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.email_address}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.contact_person}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.contact_number}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.applied_date}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm" v-if="row.status == 0">Pending</span>
                <span class="name mb-0 text-sm text-success" v-if="row.status == 1">Approved</span>
                <span class="name mb-0 text-sm text-danger" v-if="row.status == 2">Rejected</span>
              </div>
            </div>
          </td>
        </template>
      </base-table>
    </div>
    <div
      class="card-footer d-flex justify-content-end"
      :class="type === 'dark' ? 'bg-transparent': ''"
    >
      <base-pagination :perPage="10" :total="totalEmployers" :value="pageNumber"></base-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: "employers-by-status-table",
  props: {
    type: {
      type: String
    },
    title: String,
    status: String
  },
  data() {
    return {
      totalEmployer: 0,
      search_text: ""
    };
  },
  computed: {
    employers() {
      return this.$store.getters.employers;
    },
    pageNumber() {
      return parseInt(this.$route.query.page);
    },
    totalEmployers() {
      return this.totalEmployer;
    }
  },
  watch: {
    pageNumber() {
      this.getEmployers(this.$route.query.page);
    },
    status: function() {
      this.getEmployers(this.$route.query.page);
    }
  },
  mounted() {
    this.getEmployers(parseInt(this.$route.query.page));
    this.getTotalEmployer();
  },
  methods: {
    getEmployers: function(page_number) {
      this.$store
        .dispatch("fetchEmployers", 
        {
          keyword: this.search_text,
          page: page_number,
          status: this.status
        })
        .then(response => {
          const { data, meta } = response.data;
          this.totalEmployer = meta.total_result;
          this.$router.push({ query: { page: page_number } });
          this.$store.dispatch("updateState", {
            key: "employers",
            value: data
          });
        });
    },

    getEmployer: function(company_id) {
      this.$store
        .dispatch("fetchEmployer", {
          id: parseInt(company_id)
        })
        .then(response => {
          let responseData = response.data;
          this.employer.companyName = responseData.company_name;
          this.employer.companyReg = responseData.registration_number;
          this.employer.industry = responseData.industry;
          this.employer.pic = responseData.pic;
          this.employer.contactNo = responseData.contact_number;
          // this.employer.emailAddress = responseData.email_address;
          this.employer.website = responseData.website;
          this.employer.isAnonymous =
            responseData.is_anonymous == 1 ? true : false;
          this.employer.dressCode = responseData.dress_code;
          this.employer.companySize = responseData.company_size;
          this.employer.workingHoursStart = responseData.working_hours.split(
            "-"
          )[0];
          this.employer.workingHoursEnd = responseData.working_hours.split(
            "-"
          )[1];
          this.employer.spokenLanguage = responseData.spoken_language;
          this.employer.overview = responseData.overview;
          this.employer.line1 = responseData.line_1;
          this.employer.line2 = responseData.line_2;
          this.employer.town = responseData.city;
          this.employer.postalCode = responseData.postcode;
          this.employer.state = responseData.state;
          this.employer.country = responseData.country;
          this.employer.latitude = responseData.latitude;
          this.employer.longitude = responseData.longitude;
          this.employer.loginEmail = responseData.email_address;
          this.employer.logo = responseData.logo;
        });
    },

    getTotalEmployer() {
      this.$store
        .dispatch("fetchTotalEmployer", { status: this.status })
        .then(response => {
          let responseData = response.data;
          this.totalEmployer = parseInt(responseData);
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>
<style>
</style>
